var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoleManagement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.0002 11C10.1048 11 11.0002 10.1046 11.0002 9C11.0002 7.89543 10.1048 7 9.0002 7C7.89563 7 7.0002 7.89543 7.0002 9C7.0002 10.1046 7.89563 11 9.0002 11Z",
    stroke: "#0B0A0A",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0002 15C13.0002 16.1046 13.0002 17 9.0002 17C5.0002 17 5.0002 16.1046 5.0002 15C5.0002 13.8954 6.79106 13 9.0002 13C11.2093 13 13.0002 13.8954 13.0002 15Z",
    stroke: "#0B0A0A",
    strokeWidth: 1.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0002 12C22.0002 15.7712 22.0002 17.6569 20.8286 18.8284C19.6571 20 17.7714 20 14.0002 20H10.0002C6.22896 20 4.34335 20 3.17177 18.8284C2.0002 17.6569 2.0002 15.7712 2.0002 12C2.0002 8.22876 2.0002 6.34315 3.17177 5.17157C4.34335 4 6.22896 4 10.0002 4H14.0002C17.7714 4 19.6571 4 20.8286 5.17157C21.2982 5.64118 21.5796 6.2255 21.7482 7",
    stroke: "#0B0A0A",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0002 12H15.0002",
    stroke: "#0B0A0A",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0002 9H14.0002",
    stroke: "#0B0A0A",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0002 15H16.0002",
    stroke: "#0B0A0A",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoleManagement);
export default __webpack_public_path__ + "static/media/role-management.3086d4eedca8a2dada192fcfe27f9014.svg";
export { ForwardRef as ReactComponent };